module.exports = __webpack_public_path__ + "img/cross.6ec55d3b.svg";